const theme = {
    primary: "#3E517B",
    secondary: "#C8102E"
}

export default theme;